import { render, staticRenderFns } from "./SchoolIntegrations.vue?vue&type=template&id=55b8dc3c&scoped=true&"
import script from "./SchoolIntegrations.vue?vue&type=script&lang=js&"
export * from "./SchoolIntegrations.vue?vue&type=script&lang=js&"
import style0 from "./SchoolIntegrations.vue?vue&type=style&index=0&id=55b8dc3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b8dc3c",
  null
  
)

export default component.exports